import Lottie from 'react-lottie';
import LoadingJson from './assets/loading-dots.json';

export function LoadingDots() {
  return (
    <Lottie
      options={{ loop: true, autoplay: true, animationData: LoadingJson }}
      isClickToPauseDisabled
    />
  );
}
